import { ComponentConfig, FieldLabel } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../../page-builder/puck/reusable-props/NewMargin';
import {
  paddingFields,
  PaddingProps,
} from '../../../../page-builder/puck/reusable-props/padding';
import { Switch } from '@mui/material';
import { ReduxSelectorProps } from '../../../services/constants';
import CustomTooltip from '../../../../components/common/tooltip';
import {
  getBorderProps,
  getcurrentDeviceType,
  getNewMarginStyles,
  getPaddingStyles,
} from '../../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import WithAccordion from '../../customComponents/CustomAccordion';
import QuilHelper from '../../../puck/reusable-props/quilHelper';
import BackgroungColorComponent, {
  IBackgroundProps,
} from '../../customComponents/BackgroungColorComponent';

export type HeaderProps = {
  border: IBorderValueProps;
  headerCustamize: {
    content: string;
    background: IBackgroundProps;
    hideOfferValue: boolean;
  };
} & MarginProps &
  PaddingProps &
  showComponentProps;

export const Header = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<HeaderProps> => {
  return {
    label: (
      <CustomTooltip title="Header Text">
        <span>Header</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      headerCustamize: {
        type: 'custom',
        label: 'Header Customize',
        render: ({ value, onChange }) => {
          return (
            <>
              <WithAccordion title="Header Customize">
                <>
                  <QuilHelper
                    value={value.content}
                    onChange={val => {
                      onChange({
                        ...value,
                        content: val,
                      });
                    }}
                    enableLink={true}
                  />

                  <div className="mt-3">
                    <BackgroungColorComponent
                      value={value?.background}
                      onChange={backhround => {
                        onChange({
                          ...value,
                          background: backhround,
                        });
                      }}
                    />
                  </div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip title="Hide Offer Amount">
                          <span>Hide Offer Amount</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }>
                    <Switch
                      className="flex justify-between items-center mb-3"
                      checked={value?.hideOfferValue}
                      onChange={e => {
                        const selectedValue = e.target.checked;
                        onChange({
                          ...value,
                          hideOfferValue: selectedValue,
                        });
                      }}
                    />
                  </FieldLabel>
                </>
              </WithAccordion>
            </>
          );
        },
      },
    },
    defaultProps: {
      headerCustamize: {
        content:
          '<p style="line-height:1.5;"><span style="font-size: 24px;">WAIT! YOUR ORDER ISNT COMPLETE</span></p>',
        background: {
          color: '#ffffff',
          isInherit: false,
        },
        hideOfferValue: false,
      },

      showComponent: ['desktop', 'tablet', 'mobile'],
      margin: {
        deviceType: 'desktop',
        marginBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      ...borderProps,
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
    },
    render: ({
      margin,
      padding,
      showComponent,
      border,
      headerCustamize,
      editMode,
    }) => {
      const postUpsell = useAppSelector(state => state.postUpSell);
      const postUpSellRecommendation = postUpsell.postUpsellData;
      const postUpsellState = useAppSelector(state => state.postUpSellState);
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getNewMarginStyles(margin, currentDeviceType);
      const borderStyles = getBorderProps(border, currentDeviceType);

      const currentRecommendation =
        postUpSellRecommendation?.[postUpsellState?.currentIndex];

      const containerStyle: React.CSSProperties = {
        backgroundColor: headerCustamize.background?.isInherit
          ? 'inherit'
          : headerCustamize.background?.color,
      };

      return (
        <div
          style={{
            ...marginStyles,
            ...borderStyles,
            ...getPaddingStyles(padding, currentDeviceType),
            ...containerStyle,
          }}
          className={`flex flex-col text-center  text-editor-content ${border?.borderStyle?.[currentDeviceType]}`}>
          <div>
            {showComponent?.includes(currentDeviceType) && (
              <h1
                dangerouslySetInnerHTML={{ __html: headerCustamize.content }}
              />
            )}
            {!headerCustamize.hideOfferValue && (
              <h2 className="text-center">
                SAVE{' '}
                {(
                  Number(postUpsellState?.selectedVariant?.OriginalPrice || 0) -
                  Number(postUpsellState?.selectedVariant?.Price || 0)
                ).toFixed(2)}{' '}
                OFF OUR {currentRecommendation?.Title}
              </h2>
            )}
          </div>
        </div>
      );
    },
  };
};
